











import Vue, { PropOptions } from 'vue';
import { Campaign, CampaignStatus } from '@/models';
import ButtonAction from '@/components/ButtonAction.vue';
export default Vue.extend({
  components: { ButtonAction },
  props: {
    campaign: Object as PropOptions<Campaign>,
  },
  methods: {
    async edit() {
      this.$store.commit('setCampaign', this.campaign);
      this.$store.dispatch('refreshShortLinks', this.campaign.objectId);
      this.$router.push(`/campaign/${this.campaign.objectId}/edit`);
    },
  },
});
